module.exports = __webpack_public_path__ + "img/5.dd3059ec.jpg";